import Vue from 'vue'
import vuetify from './plugins/vuetify'
import store from "./store/index.js";
import App from './App.vue';
import router from './router/index.js'
import VueMeta from 'vue-meta'

Vue.use(VueMeta)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,

  render: h => h(App)
}).$mount('#app')
